import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const tableSelector = '.js-comparison-table';
	const breakColumnOn = '.js-comparison-table-column-header';
	const cellSelector = '.js-comparison-list-item';
	const bottomComparisonCardSelector = '.js-comparison-card-bottom';
	const listItemClass = 'block-comparison-list-item';

	const table = document.querySelectorAll(tableSelector);

	if (!table.length) {
		return;
	}
	const { ComparisonTableGridHelper } = await import('./comparison-table-grid-helper');

	table.forEach((tableElement) => {
		const tableHelper = new ComparisonTableGridHelper({
			tableElement,
			breakColumnOn,
			cellSelector,
			bottomComparisonCardSelector,
			listItemClass,
		});
		tableHelper.init();
	});
});
